import React, { useState, useEffect } from "react";
import { auth, googleProvider } from "../firebaseConfig"; // Import Firebase
import {
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import "./MyAccount.css"; // Add CSS styling

const MyAccount = () => {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false); // Toggle between login/signup
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility
  const navigate = useNavigate();

  // Check if user is logged in
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Handle email/password login
  const handleAuth = async () => {
    try {
      if (isSignup) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (error) {
      alert(error.message);
    }
  };

  // Handle Google Login
  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (error) {
      alert(error.message);
    }
  };

  // Handle Forgot Password
  const handleForgotPassword = async () => {
  if (!email) {
    alert("Please enter your email to reset password.");
    return;
  }

  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset email sent! Check your inbox.");
  } catch (error) {
    alert(error.message);
  }
};


  // Handle Logout
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/"); // Redirect to home after logout
  };

  // Function to navigate to the project page
  const goToProject = () => {
    window.location.href = "/vendor-form"; // Change this to your actual project route
  };

  return (
    <div className="my-account-container">
      {user ? (
        <div className="logged-in">
          <h2>Welcome, {user.displayName || user.email}</h2>
          <p>You are logged in.</p>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
          <button className="connect-now-btn" onClick={goToProject}>
              Vendor Registration Form
            </button>
        </div>
      ) : (
        <div className="auth-container">
          <h2>Welcome!</h2>
          <h3>{isSignup ? "Sign Up" : "Login"}</h3>
          <label className="input-label">Email:</label>
          <input className="password"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label className="input-label">Password:</label>
            <input className="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="eye-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>

           

         
        <div className="three-btn">
          <button onClick={handleAuth} className="auth-btn">
            {isSignup ? "Sign Up" : "Login"}
          </button>
          <button onClick={handleGoogleLogin} className="google-btn">
            Login with Google
          </button>
          <button className="forgot-password-btn" onClick={handleForgotPassword}>
              Forgot Password?
            </button>
          <p onClick={() => setIsSignup(!isSignup)} className="toggle-text">
            {isSignup ? "Already have an account? Login" : "New user? Sign Up"}
          </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAccount;
